import {ProgressSerie} from '../components/charts/components/progressBar/progressBarSerie';

/*
 * Types.
 */

export enum AnalyticsComputedMetricTypesEnum {
  CUSTOM_GRAPH = 'custom_graph',
  CUSTOM_PROGRESS = 'custom_progress',
}

export enum AnalyticsComputedGraphMetricsEnum {
  WHAT_HAPPENED_GRAPH = 'what_happened_graph',
  SANKEY_GRAPH = 'sankey_graph',
  REPLY_TIME_GRAPH = 'reply_time_graph',
  FIRST_REPLY_TIME_GRAPH = 'first_reply_time_graph',
  CSAT_SURVEY_RESPONSE_HISTO_GRAPH = 'csat_survey_response_histo_graph',
  // The enum value for these two must be different from the AnalyticsGraphMetricsEnum entries that share the same key.
  STAGE_AVG_RESOLUTION_TIME_GRAPH = 'stage_avg_resolution_time_computed_graph',
  STAGE_AVG_REPLIES_TO_RESOLUTION_GRAPH = 'stage_avg_replies_to_resolution_computed_graph',
}

export enum AnalyticsComputedProgressMetricsEnum {
  TAG_REPORT_PROGRESS = 'tag_report_progress',
  STAGE_RESOLVED_SEGMENTS_PROGRESS = 'stage_resolved_segments_progress',
  MESSAGE_TEMPLATE_REPORT_PROGRESS = 'message_template_progress',
}

// This interfaces should be used in transformers return interfaces (with values).
export interface AnalyticsComputedGraphMetricBase<T> {
  id: AnalyticsComputedGraphMetricsEnum;
  metricType: AnalyticsComputedMetricTypesEnum;
  values: ReadonlyArray<T>;
  isEmpty: boolean;
}

export interface AnalyticsComputedProgressMetricBase {
  id: AnalyticsComputedProgressMetricsEnum;
  metricType: AnalyticsComputedMetricTypesEnum;
  series: ReadonlyArray<ProgressSerie>;
  isEmpty: boolean;
}
